import React from 'react';
import { CustomThemeButton, type CustomThemeButtonProps } from '@atlaskit/button';
import { useEntryPointButtonTrigger } from '@atlassian/jira-entry-point-button-trigger/src/index.tsx';
import { ModalEntryPointContainer } from '@atlassian/jira-entry-point-modal-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { entryPointPremiumUpgradeModal } from '../../entrypoint.tsx';

const entryPointParams = {};
export const PremiumUpgradeModalEntryPointButton = (
	buttonProps: Exclude<CustomThemeButtonProps, 'ref'>,
) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		entryPointPremiumUpgradeModal,
		entryPointParams,
	);
	const buttonTrigger = useEntryPointButtonTrigger(entryPointActions);
	return (
		<>
			<CustomThemeButton {...buttonProps} ref={buttonTrigger} />
			<ModalEntryPointContainer
				entryPointReferenceSubject={entryPointReferenceSubject}
				id="jira-premium-upgrade-modal"
				packageName="jiraPremiumUpgradeModal"
				errorFallback="flag"
				runtimeProps={{ onClose: entryPointActions.unload }}
				entryPointActions={entryPointActions}
			/>
		</>
	);
};
